import axios from 'axios'
import AuthService from '@/services/AuthService';

const instance = axios.create({
    baseURL: process.env.VUE_APP_MASTERS_API_URL
});


export default {
    getAudienceRoles: async function (query = '') {
        try {
            const response = await instance.get(`audienceRoles`+query);
            return response;
        } catch (error) {
            console.info('error: ', error.lineNumber)
            return error.response;
        }
    },
    updateAudienceRole: async function (data,id) {
        try {
            const response = await instance.put('audienceRoles?id='+id, data);
            return response;
        } catch (error) {
            return error.response;
        }
    },
    createAudienceRoles : async function (data) {
        try {
            const response = await instance.post('audienceRoles', data);
            return response;
        } catch (error) {
            return error.response;
        }
    },
    deleteAudienceRole : async function (ids) {
        try {
            const response = await instance.delete('audienceRoles', { data: ids });
            return response;
        } catch (error) {
            return error.response;
        }
    },
    deleteBulkAudienceRoles : async function (ids) {
        try {
            const response = await instance.delete('audienceRoles'+ids,
             { headers: {
                'Authorization': AuthService.getToken()
              }
            })
            return response;
        } catch (error) {
            return error.response;
        }
    },
    getAudienceRoleGroups: async function(){
        try {
            const response = await instance.get(`getAudienceRoleGroups`);
            
            return response;
            
        } catch (error) {
            console.info('error: ', error.lineNumber)
            return error.response;
        }
    },

    getHiringManagerEmailId: async function(audienceRoleId) {
        try {
            const response = await instance.get('getHiringManagerEmail?audienceRoleId='+audienceRoleId);
            return response;
        } catch (error) {
            return error.response;
        }
    },
    getAudienceRolesByDepartment: async function (audienceRoleGroupId = null, department = null) {
        try {
            const response = await instance.get(`audienceRoles?audienceRoleGroupId=${audienceRoleGroupId}&department=${department}`);
            return response;
        } catch (error) {
            console.info('error: ', error.lineNumber)
            return error.response;
        }
    },
    getAudienceRoleDepartmentsByDepartmentGroupId: async function(audienceRoleGroupId = null){
        try {
            const response = await instance.get(`getDepartmentsByAudienceRoleGroupId?audienceRoleGroupId=${audienceRoleGroupId}`);
            return response;
        } catch (error) {
            console.info('error: ', error.lineNumber)
            return error.response;
        }
    },
    getJobTypeByName: async function (jobType) {
        try {
          const response = await instance.get(`/getJobTypeByName`, {
            params: { jobType }
          });
          return response;
        } catch (error) {
          return error.response;
        }
    },
    getDepartments: async function () {
        try {
            const response = await instance.get('getDepartmentsByAudienceRoleGroupId',{});
            return response;
        }
        catch(error) {
            return error.response;
        }
    },
    fetchUserAssessmentMap : async (audienceRoleGroupId) => {
        try{
            const response = await instance.get('fetchUserAssessmentMap',  {
                params: { audienceRoleGroupId },
              })
              return response.data;
        }
        catch(error){
            console.error(error);
            return;
        }
    },
    fetchAssessmentCategories : async (skillIds) => {
        try{
            skillIds = skillIds.join(",");
            const response = await instance.get('fetchAssessmentCategories',  {
                params: { skillIds },
              })
              return response.data;
        }
        catch(error){
            console.error(error);
            return;
        }
    },
    fetchSections : async (assessmentSectionId) => {
        try{
            // skillIds = skillIds.join(",");
            // grades = grades.join(",");
            const response = await instance.get('fetchSections',  {
                params: {assessmentSectionId},
              })
              return response.data;
        }
        catch(error){
            console.error(error);
            return;
        }
    },
    getMasterFilters: async function (docId) {
        try {
            const response = await instance.get(`get-master-filters/${docId}`);
            console.log('response',response)
            return response.data;
        } catch (error) {
            return error.response;
        }
    },
    getAudienceRolesFromMDM: async ({page, pageSize, department, searchQuery }) => {
        try{
            const response = await instance.get('get-mdm-audience-roles', {
                params: { page, pageSize, department, searchQuery}
            })

            return response.data;
        }
        catch(error){
            return error.response;
        }
    },
    getDepartmentsFromMDM: async ({page, pageSize}) => {
        try{
            const response = await instance.get('/get-mdm-departments', {
                params: {page, pageSize }
            })
            return response.data;
        }
        catch(error) {
            return error.response;
        }
    }
}